import React, { useEffect, useState } from "react";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import { Icon } from "semantic-ui-react";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import NoData from "../NoData/NoData";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import InstagramPageSelector from "../InstagramPageSelector";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import { kmFormatter } from "../../../../../Dashboard/Charts/utils";
import Loading from "../Loading/Loading";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import "../../../TwitterInsights/components/RecentPosts/RecentPosts.scss";
import IgPost from "./IgPost";
import CustomDropdown from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";
import "./IgRecentPosts.scss";

function IgRecentPosts(props) {
    const [isNoData, setIsNoData] = useState(false);
    // const [activateRef, setActivateRef] = useState(false);
    const chart = React.useRef(null);
    const carouselRef = React.useRef(null);
    const [currentScroll, setCurrentScroll] = useState(0);

    const chartLoading = props.chartDataLoading?.IgRecentPosts;

    let totalData = props.data || [];

    // useEffect(() => {
    //     setActivateRef(!activateRef);

    //     return () => {
    //         setActivateRef(!activateRef);
    //     };
    // }, []);

    useEffect(() => {
        let recentPosts = props.pageStatus || props.data?.length === 0 ? true : false;
        setIsNoData(recentPosts);
    }, [props.data, props.pageStatus]);

    const nextPage = () => {
        carouselRef.current.scrollBy({
            left: carouselRef.current.clientWidth,
            behavior: "smooth",
        });
        setCurrentScroll(currentScroll + 1);
    };

    const previousPage = () => {
        carouselRef.current.scrollBy({
            left: -carouselRef.current.clientWidth,
            behavior: "smooth",
        });
        setCurrentScroll(currentScroll - 1);
    };

    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };
    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            obj["handler"] = item.page_username;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            obj["handler"] = item.page_username;
            props.setSelectedInstagramPage(obj);
        }
    };
    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            obj["handler"] = item.page_username;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            obj["handler"] = item.page_username;
            props.setSelectedInstagramPage(obj);
        }
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    isIGPage={props.isIGPage}
                    name={props.widget?.name || "Recent Posts"}
                    info="This section shows posts based on the sorting options selected."
                />

                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isIGPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}

                    {props.isIGPage || (props.isPublic && isNoData) ? null : (
                        <Popup
                            className="skiptranslate"
                            trigger={
                                props.expand ? (
                                    <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                ) : (
                                    <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                )
                            }
                            inverted
                            content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                            size="mini"
                            position="bottom center"
                            style={{ zIndex: "99999" }}
                        />
                    )}

                    {props.isPublic && isNoData ? null : (
                        <MoreOptions
                            className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                            onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
                {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        <CustomDropdown
                            className="interval-selector"
                            name="Post Type"
                            options={[
                                { label: "All", value: "all" },
                                { label: "Photos", value: "image" },
                                { label: "Videos", value: "video" },
                            ]}
                            value={props.recentPostsType}
                            onChange={props.setRecentPostsType}
                        />
                        <CustomDropdown
                            className="interval-selector"
                            name="Sort By"
                            options={props.postOrderByList}
                            value={props.postOrderBy}
                            onChange={props.changePostOrderBy}
                        />
                        {!props.isIGPage &&
                            !props.isPublic &&
                            !props.isStandardDashboard &&
                            !props.isResearchDashboard &&
                            props.dashboardPageType !== "temporaryInsights" &&
                            props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    <DeleteWidget onClick={props.deleteWidget} />
                                </>
                            )}
                    </ChartOptionsSidebar>
                )}
            </div>

            <div className="dashboard-chart dashboard-chart-slider skiptranslate">
                {!props.isIGPage && (
                    <div data-html2canvas-ignore="true" className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}>
                        <ArrowIcon onClick={() => decrement()} />
                    </div>
                )}
                <div className="chart-area" ref={chart}>
                    {!props.isIGPage && (
                        <InstagramPageSelector
                            selectedPage={props.selectedInstagramPage}
                            setSelectedPage={props.setSelectedInstagramPage}
                            pageList={props.instagramPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    {chartLoading && <Loading />}
                    {isNoData && !chartLoading && (
                        <div className={`${props.isIGPage ? "no__data-page-text" : "m-top"}`}>
                            <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                        </div>
                    )}
                    {!isNoData && !chartLoading && (
                        <div className="recentPosts">
                            {props.isIGPage && totalData?.length > 3 && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )}
                            {!props.isIGPage && totalData?.length > 1 && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )}

                            {/* {carouselRef.current?.scrollWidth > carouselRef.current?.clientWidth && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )} */}

                            <div className="carousel" ref={carouselRef}>
                                {totalData.map((post, index) => (
                                    <IgPost key={index} data={post} />
                                ))}
                            </div>

                            {/* {carouselRef.current?.scrollWidth > carouselRef.current?.clientWidth && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )} */}

                            {props.isIGPage && totalData?.length > 3 && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )}
                            {!props.isIGPage && totalData?.length > 1 && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {!props.isIGPage && (
                    <div data-html2canvas-ignore="true" className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}>
                        <ArrowIcon onClick={() => increment()} />
                    </div>
                )}
            </div>
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}
export default IgRecentPosts;
